module.exports = function (a) {
    var guid = $(this).data('guid');

    $.ajax({
        type: "GET",
        url: laroute.route('public::lists::ajax::buy_list', {guid: guid})
    }).done(function (msg) {
        if (msg.error) {
            $.sticky('<b>' + msg.list + '</b><br />' + msg.message, {
                autoclose: 3000,
                position: 'top-right',
                type: 'st-error'
            });
        } else {
            bootbox.confirm("<b>" + msg.list + "</b><br />" + msg.message, function (confirmed) {
                if (confirmed) {
                    $.ajax({
                        type: "POST",
                        url: laroute.route('public::lists::ajax::buy_list', {guid: guid})
                    }).done(function (msg) {
                        if (!msg.error) {
                            $('.add-to-cart-track-btn').remove();
                            $('.buy-now-track-btn').remove();
                            $('.buy-now-list-btn').remove();

                            if (msg.url)
                                location.href = msg.url;
                        }

                        bootbox.alert('<b>' + msg.list + '</b><br />' + msg.message, function () {});
                    });
                }
            });
        }
    });

}
